export enum NewsletterMixpanelEvents {
	OpenNewsletterDialog = 'NEWSLETTER/OPEN_DIALOG',
	SubmitNewsletter = 'NEWSLETTER/SUBMIT',
	NewsletterFormFunnel = 'NEWSLETTER/FORM_FUNNEL',
}

export enum NewsletterFunnelStage {
	Started = 'started',
	Abandoned = 'abandoned',
	Failed = 'failed',
}

// Unsubscribes ride on the same funnel event so that every newsletter failure
// is reachable in one query. Signup conversion must filter to `Subscribe`,
// since an unsubscribe is not part of the started/abandoned/submitted maths.
export enum NewsletterFunnelAction {
	Subscribe = 'subscribe',
	Unsubscribe = 'unsubscribe',
}

// What counts as "started" depends on how prominent the form is. A dialog or a
// dedicated page is deliberate — being shown the form is already intent. A
// footer or mid-page form is passive furniture that scrolls past, so only a
// keystroke shows intent there; firing on mount would flood the funnel with
// non-intent and make the attempt-to-success rate meaningless.
export enum NewsletterStartTrigger {
	Mount = 'mount',
	Interaction = 'interaction',
}

export enum NewsletterProvenance {
	About = 'about-page',
	DropPageDialog = 'drop-page-dialog',
	DropPage = 'drop-page',
	Artist = 'artist-page',
	Footer = 'footer',
	Home = 'home-page',
	ShopHome = 'shop-home',
	PublishingHome = 'publishing-home-page',
	EditionsHome = 'editions-home-page',
	ExhibitionsHome = 'exhibitions-home-page',
	PrimaryHome = 'primary-home-page',
	PrimaryAllReleases = 'primary-all-releases-page',
	RegisterInterest = 'register-interest-page',
	PrimaryApply = 'primary-apply-page',
	NftVerify = 'nft-verify-page',
	HatRegister = 'hat-register-page',
	Invoice = 'invoice-page',
	PrimaryApplication = 'primary-application-page',
	PublishingCheckout = 'publishing-checkout-page',
	ShopCheckout = 'shop-checkout-page',
	ShopCollections = 'shop-collections-page',
	TalksHome = 'talks-home-page',
	EditionsCheckout = 'editions-checkout-page',
	PrimaryCheckout = 'primary-checkout-page',
	NftRedemption = 'nft-redemption-page',
	MerchCheckout = 'merch-checkout-page',
	NewsHome = 'news-home-page',
	NftHome = 'nft-home-page',
	LiveDropsPage = 'live-drops-page',
	GlobalHomeLatestReleases = 'global-home-latest-releases',
}
